import {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useState,
} from "react";

import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";


const FarmContext =
  createContext(null);


export const useFarm = () =>
  useContext(FarmContext);


export function FarmProvider({
  children,
}) {
  const { user } =
    useAuth();


  const [
    farms,
    setFarms,
  ] = useState([]);


  const [
    farmId,
    setFarmId,
  ] = useState(
    localStorage.getItem(
      "fh_farm"
    ) || null
  );


  const [
    loading,
    setLoading,
  ] = useState(true);


  const refresh =
    useCallback(
      async () => {
        try {
          const { data } =
            await api.get(
              "/farms"
            );


          setFarms(
            data
          );


          if (
            data.length === 0
          ) {
            setFarmId(
              null
            );

            localStorage.removeItem(
              "fh_farm"
            );

            return data;
          }


          const selectedStillExists =
            data.some(
              (farm) =>
                farm.id ===
                farmId
            );


          if (
            !selectedStillExists
          ) {
            const firstFarm =
              data[0];

            setFarmId(
              firstFarm.id
            );

            localStorage.setItem(
              "fh_farm",
              firstFarm.id
            );
          }


          return data;

        } finally {
          setLoading(
            false
          );
        }
      },
      [
        farmId,
      ]
    );


  useEffect(
    () => {
      if (
        user &&
        user.id
      ) {
        refresh();
      }
    },
    [
      user,
      refresh,
    ]
  );


  const selectFarm =
    (id) => {
      if (!id) {
        setFarmId(
          null
        );

        localStorage.removeItem(
          "fh_farm"
        );

        return;
      }


      setFarmId(
        id
      );

      localStorage.setItem(
        "fh_farm",
        id
      );
    };


  const farm =
    farms.find(
      (item) =>
        item.id ===
        farmId
    ) || null;


  const isClientFarm =
    farm?.farm_type ===
    "consultant_client";


  return (
    <FarmContext.Provider
      value={{
        farms,
        farm,
        farmId,
        selectFarm,
        refresh,
        loading,
        isClientFarm,
      }}
    >
      {children}
    </FarmContext.Provider>
  );
}